import type { AnyAction } from 'redux';

import type { Cart, CartLineItem } from 'src/app/state/types/cart';

const defaultState: Cart = {
  orderId: null,
  lineItems: [],
  promoCode: undefined,
};

const RESET = 'session/cart/RESET';
const UPDATE_CART_PROMO_CODE = 'session/cart/promoCode/UPDATE';
const UPDATE_CART_ORDER_ID = 'session/cart/orderId/UPDATE';
const UPDATE_CART = 'session/cart/lineItems/UPDATE';
const UPDATE_CART_LINE_ITEM = 'session/cart/lineItem/UPDATE';
const REMOVE_CART_LINE_ITEM = 'session/cart/lineItem/REMOVE';

export const actionResetCart = () => ({
  type: RESET,
});

export const actionUpdateCart = (value: CartLineItem[]) => ({
  type: UPDATE_CART,
  value,
});

export const actionUpdateCartOrderId = (value: string | null) => ({
  type: UPDATE_CART_ORDER_ID,
  value,
});

export const actionUpdateCartPromoCode = (value: string) => ({
  type: UPDATE_CART_PROMO_CODE,
  value,
});

export const actionUpdateCartLineItem = (value: CartLineItem) => ({
  type: UPDATE_CART_LINE_ITEM,
  value,
});

export const actionRemoveCartLineItem = (value: string) => ({
  type: REMOVE_CART_LINE_ITEM,
  value,
});

export default (state: Cart = defaultState, action: AnyAction) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE_CART_ORDER_ID: {
      return {
        ...state,
        orderId: action.value,
      };
    }

    case UPDATE_CART: {
      return {
        ...state,
        lineItems: [...action.value],
      };
    }

    case UPDATE_CART_LINE_ITEM: {
      const existingProductIndex = state.lineItems.findIndex(
        (lineItem) => lineItem.productId === action.value.productId,
      );

      if (existingProductIndex < 0) {
        return {
          ...state,
          lineItems: state.lineItems.concat(action.value),
        };
      }

      return {
        ...state,
        lineItems: state.lineItems.map((item, index) => {
          if (index !== existingProductIndex) {
            return item;
          }

          return {
            ...item,
            ...action.value,
          };
        }),
      };
    }
    case REMOVE_CART_LINE_ITEM: {
      const existingProductIndex = state.lineItems.findIndex(
        (lineItem) => lineItem.productId === action.value,
      );

      if (existingProductIndex < 0) {
        return state;
      }

      return {
        ...state,
        lineItems: [
          ...state.lineItems.slice(0, existingProductIndex),
          ...state.lineItems.slice(existingProductIndex + 1),
        ],
      };
    }
    case UPDATE_CART_PROMO_CODE: {
      return {
        ...state,
        promoCode: action.value,
      };
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE_CART_ORDER_ID,
  UPDATE_CART_PROMO_CODE,
  UPDATE_CART_LINE_ITEM,
  REMOVE_CART_LINE_ITEM,
};
